module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "font-style": "italic",
      "page-break-before": "always",
      "text-align": "justify"
    }
  }, [_vm._v("Desprovida de beleza e também de fortuna, a solteirona Srta. Jane Featherstone não conseguiu atrair nenhum pretendente durante a temporada em que foi apresentada à sociedade. Em vez de ser um fardo para seu irmão e sua detestável esposa, a Srta. Featherstone jurou aceitar o primeiro homem que a pedisse em casamento—embora ela sempre tenha adorado um lord que está muito acima de todos os seus sonhos... ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Lord Slade deve se casar com uma herdeira para honrar A Promessa que fez a seu pai em seu leito de morte, e ele precisa da ajuda da Srta. Featherstone para cortejar sua bela prima. Após sua raiva inicial, a Srta. Featherstone concorda com seu esquema, dizendo a ele que está fazendo isso porque admira seu histórico parlamentar de legislação humanitária e sua reverência pela verdade. Mas quanto mais tempo ele passa com as duas primas, mais atraído ele fica pela Srta. Featherstone. O que um homem de palavra deve fazer? Quebrar A Promessa que fez a seu amado pai ou seguir seu coração e se casar com a Srta. Featherstone?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-style": "italic",
      "font-weight": "bold",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("O Conde e a Solteirona Jane")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-style": "italic",
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("(Os Lordes de Eton, Livro 2)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "large",
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Por")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Cheryl Bolen")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Copyright © 2018 por Cheryl Bolen ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("O Conde e a Solteirona Jane ")]), _vm._v("é uma obra de ficção. Nomes, personagens, lugares e incidentes são produtos da imaginação do autor ou estão sendo usados de forma fictícia. Qualquer semelhança com pessoas reais, vivas ou mortas, estabelecimentos comerciais, eventos ou localidades, é mera coincidência.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Todos os direitos reservados ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Nenhuma parte desta publicação pode ser usada, reproduzida, armazenada ou transmitida de qualquer maneira, por via eletrônica, por via impressa, ou de qualquer outra forma, sem a permissão prévia e por escrito do autor.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b8d63c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c003.vue
// module id = 66
// module chunks = 0